export const compareData= [
    {
        feature: 'unlimited story posting',
        basic: true,
        pro: true,
        business: true,
    },
    {
        feature: 'unlimited photo upload',
        basic: true,
        pro: true,
        business: true,
    },
    {
        feature: 'embedding custom content',
        basic: false,
        pro: true,
        business: true,
    },
    {
        feature: 'customize metadata',
        basic: false,
        pro: true,
        business: true,
    },
    {
        feature: 'advanced metrics',
        basic: false,
        pro: false,
        business: true,
    },
    {
        feature: 'photo downloads',
        basic: false,
        pro: false,
        business: true,
    },
    {
        feature: 'search engine indexing',
        basic: false,
        pro: false,
        business: true,
    },
    {
        feature: 'custom analytics',
        basic: false,
        pro: false,
        business: true,
    },
    
]